import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import CloseButton from './Common/CloseButton';

const SoftwareOutdatedOverlay = ({ open, onClose, downloadLink, hideDownload = false }) => {
  const showDownload = Boolean(downloadLink && !hideDownload);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2000 }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pr: 1
      }}>
        Software Outdated
        <CloseButton
          ariaLabel="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        />
      </DialogTitle>
      <DialogContent>
        Your software version is outdated. Please download the latest update.
      </DialogContent>
      {showDownload && (
        <DialogActions>
          <Button variant="contained" color="primary" href={downloadLink} target="_blank">
            Download Update
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default SoftwareOutdatedOverlay;
